// @ts-ignore
import {createSelector} from 'reselect';
// @ts-ignore
import type {InputSelector, OutputSelector} from 'reselect';

import {Session} from '../session';
import {Collections} from '../collections';
import type {CollectionState} from '../collections';
import type {User} from '../types';

type UsersModuleState = {
    users: CollectionState<User>;
};

/*
 * Given the entire redux state, pull out just the piece of state for the users reducer.
 */
const getUsersState = (state: UsersModuleState) => state.users;

/*
 * Get an array of all users models
 */
export const getAll: InputSelector<UsersModuleState, any, User[]> =
    Collections.makeGetModels(getUsersState);

export const getById: InputSelector<
    UsersModuleState,
    any,
    {
        [key: string]: User;
    }
> = createSelector(
    getUsersState,
    // @ts-ignore
    Session.getSessionStateUser,
    (usersState, sessionUser) => {
        const usersById = Collections.getById(usersState);

        // Cheap way to get the logged in user onto the model
        if (sessionUser && usersById[sessionUser.id]) {
            // @ts-ignore
            usersById[sessionUser.id].isLoggedInUser = true;
        }

        return usersById;
    }
);

/*
 * Creates an option array of user addresses for use in our react-select dropdowns.
 */
// @ts-ignore
export const getUserEmailOptions: OutputSelector<
    UsersModuleState,
    null,
    {
        id: string;
        name: string;
    }[]
> = createSelector(getAll, (users) => {
    // @ts-ignore
    return users.reduce<Array<any>>((acc, user) => {
        if (user.emails && user.isEnabled) {
            return acc.concat(
                // @ts-ignore
                user.emails.map((email) => ({
                    id: email,
                    name: formatEmail(email, user.name),
                    type: 'users',
                    userName: user.name,
                }))
            );
        }

        return acc;
    }, []);
});

function formatEmail(emailAddress: string, name: string): string {
    return `${name} <${emailAddress}>`;
}
